import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Dropdown, DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const FormActionsDropdown = ({
  formId,
  hasFormsWriteAccess
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "600",
    as: "div",
    children: /*#__PURE__*/_jsx(Dropdown, {
      "data-selenium": "form-actions-dropdown",
      buttonSize: "small",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('actions')
      }),
      children: /*#__PURE__*/_jsxs(List, {
        wrapChildren: true,
        children: [/*#__PURE__*/_jsx(Link, {
          "data-selenium": "form-actions-dropdown-view-submissions",
          disabled: !hasFormsWriteAccess,
          external: true,
          href: Routes.formSubmissions(formId),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('viewSubmissions')
          })
        }), /*#__PURE__*/_jsx(Link, {
          "data-selenium": "form-actions-dropdown-go-to-editor",
          disabled: !hasFormsWriteAccess,
          external: true,
          href: Routes.formsEditor2({
            formId
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('editor')
          })
        }), /*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsx(Link, {
          "data-selenium": "form-actions-dropdown-form-create",
          disabled: !hasFormsWriteAccess,
          external: true,
          href: Routes.newForm(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('create')
          })
        })]
      })
    })
  });
};
export default FormActionsDropdown;